import { render, staticRenderFns } from "./BsTreegridColumn.vue?vue&type=template&id=c723ff02&scoped=true&"
import script from "./BsTreegridColumn.vue?vue&type=script&lang=js&"
export * from "./BsTreegridColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c723ff02",
  null
  
)

export default component.exports